import { z } from 'zod';

//* Define your environment variables schema here, so you get type safety throughout your app
export const EnvSchema = z.object({
  API_BASE_URL: z.string(), // API URL
  CLIENTS_API_BASE_URL: z.string(), // Clients API URL
  STORAGERESOURCENAME: z.string(), // Storage resource name
  STORAGE_CONTAINER: z.string(), // Storage container
  LOW6_CLIENT_ADMIN_URL: z.string().url(), // Low6 client admin URL

  CLIENT_CODE: z.string().optional(), // Clients API code
  FEED_TOKEN: z.string().optional(), // Feed API token
  LEAGUE_NAME: z.string().optional(), // League name
});
